import { Link } from "react-router-dom";
import { Instagram, ShoppingBag, Mail, ArrowUp } from "lucide-react";

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer 
      className="bg-[var(--obvious-black)] text-[var(--obvious-white)] relative"
      data-testid="footer"
    >
      {/* Zigzag Top Border */}
      <div className="w-full h-8 bg-[var(--obvious-yellow)]" style={{
        clipPath: "polygon(0% 0%, 5% 100%, 10% 0%, 15% 100%, 20% 0%, 25% 100%, 30% 0%, 35% 100%, 40% 0%, 45% 100%, 50% 0%, 55% 100%, 60% 0%, 65% 100%, 70% 0%, 75% 100%, 80% 0%, 85% 100%, 90% 0%, 95% 100%, 100% 0%, 100% 100%, 0% 100%)"
      }} />
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {/* Logo & Tagline */}
          <div>
            <div className="border-4 border-[var(--obvious-white)] rounded-xl inline-block px-6 py-3 mb-6">
              <span className="font-['Anton'] text-3xl tracking-tight">OBVIOUS</span>
            </div>
            <p className="font-['Space_Mono'] text-lg text-gray-300 leading-relaxed">
              A collective of artists, printers &amp; sign-slingers.<br/>
              <span className="text-[var(--obvious-teal)]">Built to be seen.</span>
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-['Anton'] text-2xl mb-6 text-[var(--obvious-coral)]">
              NAVIGATE
            </h3>
            <nav className="space-y-3">
              <Link 
                to="/" 
                className="block font-['Space_Mono'] text-lg hover:text-[var(--obvious-teal)] transition-colors"
                data-testid="footer-link-home"
              >
                → Home
              </Link>
              <Link 
                to="/about" 
                className="block font-['Space_Mono'] text-lg hover:text-[var(--obvious-teal)] transition-colors"
                data-testid="footer-link-about"
              >
                → About The Collective
              </Link>
              <Link 
                to="/shop" 
                className="block font-['Space_Mono'] text-lg hover:text-[var(--obvious-teal)] transition-colors"
                data-testid="footer-link-shop"
              >
                → Shop
              </Link>
              <Link 
                to="/contact" 
                className="block font-['Space_Mono'] text-lg hover:text-[var(--obvious-teal)] transition-colors"
                data-testid="footer-link-contact"
              >
                → Get In Touch
              </Link>
            </nav>
          </div>

          {/* Social & Contact */}
          <div>
            <h3 className="font-['Anton'] text-2xl mb-6 text-[var(--obvious-yellow)]">
              CONNECT
            </h3>
            <div className="flex gap-4 mb-6">
              <a
                href="https://www.instagram.com/obvious_signs"
                target="_blank"
                rel="noopener noreferrer"
                className="p-3 border-4 border-[var(--obvious-white)] bg-transparent hover:bg-[var(--obvious-coral)] transition-colors group"
                data-testid="footer-instagram"
                aria-label="Instagram"
              >
                <Instagram size={28} strokeWidth={3} className="group-hover:text-white" />
              </a>
              <Link
                to="/shop"
                className="p-3 border-4 border-[var(--obvious-white)] bg-transparent hover:bg-[var(--obvious-yellow)] hover:text-black transition-colors group"
                data-testid="footer-shop"
                aria-label="Shop the Collective"
              >
                <ShoppingBag size={28} strokeWidth={3} />
              </Link>
              <a
                href="mailto:laura@itisobvious.co.uk"
                className="p-3 border-4 border-[var(--obvious-white)] bg-transparent hover:bg-[var(--obvious-teal)] hover:text-black transition-colors group"
                data-testid="footer-email"
                aria-label="Email"
              >
                <Mail size={28} strokeWidth={3} />
              </a>
            </div>
            <p className="font-['Space_Mono'] text-gray-400">
              laura@itisobvious.co.uk
            </p>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-16 pt-8 border-t-4 border-[var(--obvious-purple)] flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="font-['Space_Mono'] text-sm text-gray-400">
            © {new Date().getFullYear()} THE OBVIOUS COLLECTIVE. ALL RIGHTS RESERVED.
          </p>
          <button
            onClick={scrollToTop}
            className="p-3 border-4 border-[var(--obvious-teal)] bg-[var(--obvious-teal)] text-black hover:bg-transparent hover:text-[var(--obvious-teal)] transition-colors"
            data-testid="footer-scroll-top"
            aria-label="Scroll to top"
          >
            <ArrowUp size={24} strokeWidth={3} />
          </button>
        </div>
      </div>

      {/* Decorative Elements */}
      <div className="absolute top-20 right-10 w-16 h-16 bg-[var(--obvious-purple)] rounded-full opacity-30 floating" />
      <div className="absolute bottom-40 left-10 w-12 h-12 bg-[var(--obvious-coral)] rotate-45 opacity-30 floating" style={{ animationDelay: '1s' }} />
    </footer>
  );
};

export default Footer;
